import { commonThemeOptions } from '@modules/theme/constants';
import { createTheme, Theme } from '@mui/material';

const LIGHT_DRAWER_BG = '#f1f1f1';

export const lightTheme: Theme = createTheme({
  ...commonThemeOptions,
  components: {
    ...commonThemeOptions.components,
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: LIGHT_DRAWER_BG,
          backgroundImage: 'none',
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          color: '#eaeaea',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          a: {
            color: '#BFC2FF',
          },
        },
      },
    },
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#6E35CB',
      light: '#8B5DD5',
      contrastText: '#FFFFFF',
      dark: '#4D258E',
    },
    secondary: {
      main: '#B02AB0',
      light: '#BF54BF',
      dark: '#7B1D7B',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#F6F5F7',
      paper: '#FCFBFF',
    },
    error: {
      main: '#D32F2F',
      light: '#EF5350',
      dark: '#C62828',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#ED6C02',
      light: '#FF9800',
      dark: '#E65100',
      contrastText: '#FFFFFF',
      A100: 'rgba(255, 167, 38, 0.08)',
    },
    info: {
      main: '#0288D1',
      light: '#349FDA',
      dark: '#015F92',
      contrastText: '#FFFFFF',
      A100: '#01a9f4',
    },
    success: {
      main: '#2E7D32',
      light: '#4CAF50',
      dark: '#1B5E20',
      contrastText: '#FFFFFF',
    },
    text: {
      primary: 'rgba(0,0,0,0.87)',
      disabled: 'rgba(0,0,0,0.40)',
      secondary: 'rgba(0,0,0,0.60)',
    },
    sentiment: {
      negative: '#C62828',
      neutral: '#ED6C02',
      positive: '#1B5E20',
    },
    feedback: {
      chatBubble: {
        primary: '#EEE7F9',
        secondary: '#EDEDED',
      },
      audioPlayer: '#EDEDED',
      summaryCard: '#EDEDED',
      previewBg: '#f5f4f6',
      saved: '#f5e4da',
      label: '#9C27B0',
    },
    category: {
      complaint: '#D32F2F',
      improvement: '#ED6C02',
      praise: '#2E7D32',
      help: '#0288D1',
    },
    misc: {
      hotKey: {
        primary: 'rgba(77, 37, 142, 0.3)',
        disabled: 'rgba(187, 186, 189, 0.3)',
      },
      drawer: {
        background: LIGHT_DRAWER_BG,
      },
      integrations: {
        user: '#00897B',
        account: '#FF7043',
      },
    },
  },
});
